import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { LINKED_IN_COLOR } from "../../../../constants/socialColors.constant";
import { IconProps } from "../Facebook/FacebookIcon";

export const LinkedInIcon = (props: IconProps) => {
  const { active, className, size, color } = props;
  return (
    <FontAwesomeIcon
      style={{
        color: color || (active ? LINKED_IN_COLOR : "gray"),
      }}
      icon={["fab", "linkedin"]}
      className={className}
      size={size}
    />
  );
};
